// extracted by mini-css-extract-plugin
module.exports = {"foodItem":"FoodItem_foodItem__3Qy6S","btn":"FoodItem_btn__1g8s1","detailsDiv":"FoodItem_detailsDiv__2DJ4d","foodTitle":"FoodItem_foodTitle__15JOa"};